import { DateTime } from 'luxon';
import { ConfigMap, MappedValues } from 'hooks/useCustomSearchParams';
import tryParseNumber from 'data/services/string/parseNumber';

const buildAlgoliaFilters = ({
    agentId,
    filters,
}: {
    agentId: string,
    filters: MappedValues<ConfigMap>,
}) => {
    const filtersApplied: string[] = [];

    if (agentId) {
        filtersApplied.push(`agentId:${agentId}`);
    }

    if (filters.date) {
        const [start, end] = (filters.date as string).split(',').map((date) => DateTime.fromISO(date).toMillis());
        filtersApplied.push(`createdAt:${start} TO ${end}`);
    }

    if (filters.duration) {
        const [min, max] = (filters.duration as string).split(',').map((numericValue) => tryParseNumber(numericValue));
        if (min) {
            filtersApplied.push(`duration>=${min}`);
        }
        if (max) {
            filtersApplied.push(`duration<=${max}`);
        }
    }

    if (filters.direction) {
        const directions = (filters.direction as string).split(',').map((direction) => direction.trim());
        if (directions.length) {
            const directionsFilter = directions.map((direction) => `direction:${direction}`).join(' OR ');
            filtersApplied.push(directionsFilter.length > 1 ? `(${directionsFilter})` : `${directionsFilter}`);
        }
    }

    if (filters.status) {
        const statuses = (filters.status as string).split(',').map((status) => status.trim());
        if (statuses.length) {
            const statusFilter = statuses.map((status) => `status:${status}`).join(' OR ');
            filtersApplied.push(statusFilter.length > 1 ? `(${statusFilter})` : `${statusFilter}`);
        }
    }

    if (filters.flags) {
        const flags = (filters.flags as string).split(',').map((flag) => flag.trim());
        if (flags.length) {
            const flagsFilter = flags.map((flag) => `_tags:${flag}`).join(' OR ');
            filtersApplied.push(flagsFilter.length > 1 ? `(${flagsFilter})` : `${flagsFilter}`);
        }
    }

    if (filters.tags) {
        const tags = (filters.tags as string).split(',').map((tag) => tag.trim());
        if (tags.length) {
            const tagsFilter = tags.map((tag) => `tags:${tag}`).join(' OR ');
            filtersApplied.push(tagsFilter.length > 1 ? `(${tagsFilter})` : `${tagsFilter}`);
        }
    }

    return filtersApplied.join(' AND ');
};

export default buildAlgoliaFilters;
